import React, { useState, useEffect } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Button,
} from "reactstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";

function LandingNavbar() {
  const history = useHistory();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const [activeSection, setActiveSection] = useState("");
  const [isManualScroll, setIsManualScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isManualScroll) return;

      const features = document.getElementById("features");
      const pricing = document.getElementById("pricing");

      if (features && pricing) {
        const scrollY = window.scrollY;
        const featuresTop = features.offsetTop - 100;
        const pricingTop = pricing.offsetTop - 100;

        if (scrollY >= featuresTop && scrollY < pricingTop) {
          setActiveSection("features");
        } else if (scrollY >= pricingTop) {
          setActiveSection("pricing");
        } else {
          setActiveSection("");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isManualScroll]);

  const scrollToFeatures = () => {
    setIsManualScroll(true);
    const currentUrl = window.location.href;
    const pathSegments = currentUrl.split("/");
    const pageroute = pathSegments[pathSegments.length - 1];
    const scrollAction = () => {
      const featuresSection = document.getElementById("features");
      if (featuresSection) {
        setActiveSection("features");
        featuresSection.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => setIsManualScroll(false), 800);
      }
    };

    if (pageroute !== "home") {
      history.push("/home");
      setTimeout(scrollAction, 100);
    } else {
      scrollAction();
    }
  };

  const scrollToPricing = () => {
    setIsManualScroll(true);
    const currentUrl = window.location.href;
    const pathSegments = currentUrl.split("/");
    const pageroute = pathSegments[pathSegments.length - 1];
    const scrollAction = () => {
      const pricingSection = document.getElementById("pricing");
      if (pricingSection) {
        setActiveSection("pricing");
        pricingSection.scrollIntoView({ behavior: "smooth" });
        setTimeout(() => setIsManualScroll(false), 800);
      }
    };

    if (pageroute !== "home") {
      history.push("/home");
      setTimeout(scrollAction, 100);
    } else {
      scrollAction();
    }
  };

  const handleNavigate = (path) => {
    setActiveSection("");
    history.push(path);
  };
  return (
    <div>
      <Navbar light expand="lg" className="py-lg-4">
        <NavbarBrand
          onClick={() => handleNavigate("/homr")}
          className="d-flex align-items-center cursor-pointer"
        >
          <h1 className="nav_brand my-0">NextEats</h1>
        </NavbarBrand>

        <NavbarToggler onClick={toggle} className="px-0" />
        <Collapse
          isOpen={isOpen}
          navbar
          className="d-lg-flex justify-content-lg-between"
        >
          <div className="d-flex d-lg-none justify-content-end mx-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="cursor-pointer"
              width={25}
              height={25}
              onClick={() => setIsOpen(false)}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>

          <Nav
            className="me-auto d-none d-lg-flex justify-content-between w-100 ml-2 mt-1 desktop"
            style={{ maxWidth: "850px" }}
            navbar
          >
            <p
              className={`mb-0 navbar-font position-relative ${
                activeSection === "why" ? "active-link" : ""
              }`}
            >
              Why NextEats
            </p>
            <p
              className={`mb-0 navbar-font nav_links cursor-pointer ${
                activeSection === "features" ? "active-link" : ""
              }`}
              onClick={scrollToFeatures}
            >
              Features
            </p>
            <p
              className={`mb-0 navbar-font cursor-pointer nav_links ${
                activeSection === "pricing" ? "active-link" : ""
              }`}
              onClick={scrollToPricing}
            >
              Pricing
            </p>
            <p
              className={`mb-0 navbar-font position-relative nav_links cursor-pointer ${
                location.pathname === "/services" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/services")}
            >
              Our Services
            </p>
            <p
              className={`mb-0 navbar-font cursor-pointer nav_links ${
                location.pathname === "/about" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/about")}
            >
              About Us
            </p>
            <p
              className={`mb-0 navbar-font cursor-pointer nav_links ${
                location.pathname === "/faqs" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/faqs")}
            >
              FAQS
            </p>
            <p
              className={`mb-0 navbar-font cursor-pointer nav_links ${
                location.pathname === "/tutorials" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/tutorials")}
            >
              Tutorials
            </p>
            <p
              className={`mb-0 navbar-font cursor-pointer nav_links ${
                location.pathname === "/contact" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/contact")}
            >
              Contact Us
            </p>
          </Nav>
          <Nav className="me-auto d-block d-lg-none" navbar>
            <p
              className={`mb-0 ml-3 my-2 cursor-pointer ${
                activeSection === "why" ? "active-link" : ""
              }`}
              onClick={() => {}}
            >
              <span>Why NextEats</span>
            </p>
            <p
              className={`mb-0 ml-3 my-2 cursor-pointer ${
                activeSection === "features" ? "active-link" : ""
              }`}
              onClick={scrollToFeatures}
            >
              <span>Features</span>
            </p>
            <p
              className={`ml-3 my-2 cursor-pointer ${
                activeSection === "pricing" ? "active-link" : ""
              }`}
              onClick={scrollToPricing}
            >
              <span>Pricing</span>
            </p>
            <p
              className={`ml-3 my-2 w-10 cursor-pointer ${
                location.pathname === "/services" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/services")}
            >
              <span>Our Services</span>
            </p>
            <p
              className={`ml-3 my-2 cursor-pointer ${
                location.pathname === "/about" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/about")}
            >
              <span>About Us</span>
            </p>
            <p
              className={`ml-3 my-2 cursor-pointer ${
                location.pathname === "/faqs" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/faqs")}
            >
              <span>FAQS</span>
            </p>
            <p
              className={`ml-3 my-2 cursor-pointer nav_links ${
                location.pathname === "/tutorials" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/tutorials")}
            >
              <span>Tutorials</span>
            </p>
            <p
              className={`ml-3 my-2 cursor-pointer nav_links ${
                location.pathname === "/contact" ? "active-link" : ""
              }`}
              onClick={() => handleNavigate("/contact")}
            >
              <span>Contact Us</span>
            </p>
          </Nav>

          <div className="nav_buttons mr-0">
            <Button
              color="danger"
              className="py-3 px-3  mt-3 mt-md-0 mr-0"
              onClick={() => history.push("/auth/login")}
            >
              Get Started
            </Button>
          </div>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default LandingNavbar;
